import React, { memo } from 'react';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';

import { useStyles } from './useStyles';
import { NestedListItem } from '../../NestedListItem/NestedListItem';
import { documentsSort } from '../../../service/sort';
import { DocumentItem } from '../../DocumentsPage/DocumentItem/DocumentItem';

export const AirportDocuments = memo(({ docs, style }) => {
    const classes = useStyles();
    const { t: translate } = useTranslation();

    return (
        <NestedListItem
            showSign={false}
            inset={false}
            style={style}
            className={classes.listItem}
            primary={translate('labels.airportDocuments')}
            disabled={!docs.length}
        >
            {docs.sort(documentsSort).map((doc, index) => (
                <DocumentItem
                    key={index}
                    id={doc.id}
                    primaryText={`${doc.airport} ${doc.type}`}
                    secondaryText={doc.description}
                    download={get(doc, 'syncTime')}
                    downloadFormat="DD.MM.YYYY HH:mm"
                    downloadPreifix=""
                    className={classes.nested}
                />
            ))}
        </NestedListItem>
    );
});

AirportDocuments.displayName = 'AirportDocuments';
